import { render } from "./EconomyCat.vue?vue&type=template&id=3dbb3da4"
import script from "./EconomyCat.vue?vue&type=script&lang=js"
export * from "./EconomyCat.vue?vue&type=script&lang=js"

import "./EconomyCat.vue?vue&type=style&index=0&id=3dbb3da4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__